<script lang="ts">
  import { page } from "$app/stores";
  import { m } from "$lib/paraglide/messages";
  import { getLocale, locales, setLocale } from "$lib/paraglide/runtime";
  import { updateLocaleSetting } from "$lib/subscription-service";
  import { getUser } from "$lib/utils";
  import LanguageSwitcher from "./LanguageSwitcher.svelte";

  const currentYear = new Date().getFullYear();
</script>

<footer class="site-footer">
  <span>{m.copyright_brave_software({ currentYear })}</span>
  <a href="https://brave.com/terms-of-use/" target="_blank" rel="noopener noreferrer">{m.terms_of_use_link()}</a>
  <a href="https://brave.com/privacy/browser/" target="_blank" rel="noopener noreferrer">{m.privacy_policy_link()}</a>
  <a href="https://hackerone.com/brave" target="_blank" rel="noopener noreferrer">{m.report_security_issue_link()}</a>
  <LanguageSwitcher
    currentLocale={getLocale()}
    handleChange={async ({ value }) => {
      const intent = $page.url.searchParams.get("intent");
      const eventCategory = intent ? `${$page.url.pathname}?${intent}` : $page.url.pathname;

      // @ts-ignore
      window?._paq?.push(["trackEvent", eventCategory, "Language switcher", "Language switcher change", value]);

      // TODO: This should be moved to the custom `setLocale` function
      const subscriberId = getUser()?.subscriber_id;
      try {
        if (subscriberId) {
          await updateLocaleSetting(subscriberId, value);
        }
      } catch (err) {
        console.warn(err);
      }
      setLocale(value);
    }}
    {locales}
  />
</footer>

<style>
  .site-footer {
    @apply flex flex-row flex-wrap items-center justify-center;
    @apply min-h-[68px] px-xl py-2xl;

    & > :global(*) {
      @apply no-underline;
      @apply text-small-regular text-text-tertiary;
      @apply border-r border-divider-subtle px-m py-0;

      --leo-link-color: theme("colors.text.tertiary");
      --leo-link-visited-color: theme("colors.text.tertiary");
      --leo-link-hover-color: theme("colors.text.primary");

      /* Set text color without overriding Leo anchor styling */
      &:where(:not(a)) {
        color: theme("colors.text.tertiary");
      }

      &:first-child {
        @apply pl-0;
      }
      &:last-child {
        @apply border-0;
      }
    }
  }
</style>
